import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface GetVerifiedEmailsResponse extends BackendResponse {
  emails: string[];
}

export interface GetVerifiedEmailsParameters extends NextApiParams {}

export const getVerifiedEmails = withNextApi<
  GetVerifiedEmailsResponse,
  GetVerifiedEmailsParameters
>("/auth/GetVerifiedEmails", {
  method: "GET",
});
